import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Gem } from "lucide-react";
import { api } from "@/lib/api";

export const PurchaseMarquee = () => {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders/recent").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  if (!orders || orders.length === 0) return null;

  return (
    <div data-testid="purchase-marquee" className="relative border-y border-white/10 bg-[#0D0B12]/60 py-4 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {orders.map((o, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-3 text-sm text-slate-500">
            <Gem className="w-3.5 h-3.5 text-[#8B5CF6]" />
            <span className="text-slate-300 font-semibold">{o.username}</span>
            <span>purchased</span>
            <span className="text-[#A78BFA] font-semibold">{o.items.map((it) => it.name).join(", ")}</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
